"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiRouterRedirect = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
function UiRouterRedirect({ to, params }) {
    return (react_1.default.createElement(react_router_dom_1.Redirect, { to: Object.keys(params || {}).reduce((path, key) => path.replace(`:${key}`, params === null || params === void 0 ? void 0 : params[key]), to) }));
}
exports.UiRouterRedirect = UiRouterRedirect;
